import { useContext,useState,useEffect, useSyncExternalStore } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { InputClearValue, InputSeparator, TextBox, TextBoxChangeEvent, TextBoxProps,Checkbox, CheckboxChangeEvent, TextArea, NumericTextBoxChangeEvent, TextAreaChangeEvent} from '@progress/kendo-react-inputs';
import {ListBox, ListBoxItemClickEvent} from '@progress/kendo-react-listbox';

import { Button } from '@progress/kendo-react-buttons';
import { adCopyAssistanFields, AdCopyAssistantProps } from '../services/interfaces';
import { DropDownList, DropDownListChangeEvent} from '@progress/kendo-react-dropdowns';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { getAIActionUnitOptions, getAIAdCopyActions, getAIAdCopyStyles, GetOpenAIResponse } from '../services/apiService';
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query';


export function AdCopyAssistant(props:AdCopyAssistantProps){
    const [aiActions,setAIActions]=useState([]);
    const [aiUnits, setAIUnits]=useState([]);
    const [aiMaxLength, setAIMaxLength]=useState(0);
    const [aiEmojis, setAIEmojis] = useState(false);
    const [aiHashtags, setAiHashtags] = useState(false);
    const [aiStyles,setAIStyles]=useState([]);
    const [showForm,setShowForm]=useState(true);
    const [showResult, setShowResult]=useState(false);
    const [action, setAction]=useState("");
    const [selUnit,setSelUnit]=useState({});
    const [selStyle,setSelStyle]=useState({});
    const [style, setStyle]=useState("");
    const [units, setUnits]=useState("");
    const [lengthMax, setlengthMax]=useState(0);
    const [changeLength, setChangeLength]=useState(false);
    const [showEmoji,setShowEmoji]=useState(true);
    const [showHashtag,setShowHashtag]=useState(true);
    const [actionPost,setActionPost]=useState("");
    const [promptText, setPromptText]=useState("");
    const [aiMessage,setAiMessage]=useState("");
    const [aiResults, setAiResults]=useState<{ message: string }[]>([]);
    const [maxTokens, setMaxTokens]=useState(0);

    function getAdCopy(){
        var aiPrompt = "Using a/an " + style + " tone, " + action + " " + actionPost + " using no more than " + aiMaxLength + " " + units;
        if (aiEmojis){
            aiPrompt = aiPrompt+ " and include emojis";            
        }else{
            aiPrompt = aiPrompt+ " and do not include emojis";     
        }
        if (aiHashtags){
            aiPrompt=aiPrompt + " and include hashtags"
        }else{
            aiPrompt=aiPrompt + " and do not include hashtags"
        }
        aiPrompt=aiPrompt + " for the following text " + promptText;        
        setAiMessage(aiPrompt);
        console.log("MaxTokens: " + maxTokens);
        GetOpenAIResponse(aiPrompt,maxTokens).then(data=>{
            setAiResults(data);
        });
        setShowForm(false);
        setShowResult(true);
    }

    function goBack(){
        setShowForm(true);
        setShowResult(false);
    }

    const actionChange=(event:DropDownListChangeEvent)=>{
        const action=event.target.value
        console.log(action);        
        setAction(action);
        getAIActionUnitOptions(action).then(data => {
            if (data!=null){

                setAIUnits(data);
            }else{
                setAIUnits([]);
            }
        });
    }

    const unitChange=(event:DropDownListChangeEvent)=>{
        const unit=event.target.value;
        const unitName = event.target.value.subUnitName;
        const defVal=event.target.value.defaultQuantity;
        const maxVal=event.target.value.maxQuantity;
        const emoji=event.target.value.allowEmoji;
        const hashtag=event.target.value.allowHashtag
        const allowDefaultChange=event.target.value.allowQuantityAdjustments;
        const actionPostName = event.target.value.actionUnitPostName;
        const mTok=event.target.value.maxTokenBudget;
        setSelUnit(unit);
        setlengthMax(maxVal);
        console.log(action);
        setUnits(unitName);
        setActionPost(actionPostName);
        setAIMaxLength(defVal);
        setMaxTokens(mTok);
        if (allowDefaultChange!=1){
            setChangeLength(false);
        }
        if (emoji!=" "&& emoji!=null){
            var emjoiSettings=emoji.split(" ");
            if(emjoiSettings[0]=="Allow"){
                setShowEmoji(true);
            }else{
                setShowEmoji(false);
            }
            if(emjoiSettings[2]=="Yes"){
                setAIEmojis(true);
            }else{
                setAIEmojis(false);
            }
        }
        if (hashtag!=" "&& emoji!=null){
            var hashSettings=emoji.split(" ");
            if(hashSettings[0]=="Allow"){
                setShowHashtag(true);
            }else{
                setShowHashtag(false);
            }
            if (hashSettings[2]=="Yes"){
                setAiHashtags(true);
            }else{
                setAiHashtags(false);
            }
        }
    }
    const styleChange=(event:DropDownListChangeEvent)=>{
        const style=event.target.value.styleOption
        setSelStyle(event.target.value);
        setStyle(style);
    }

    const maxChange=(event:NumericTextBoxChangeEvent)=>{
        const length = event.target.value;
        if (length !=null){
            setAIMaxLength(length);
        }
    }

    const promptChange=(event:TextAreaChangeEvent)=>{
        setPromptText(event.target.value||"");
    }

    const returnResults=()=>{
        console.log(aiResults);
        props.onConfirm(aiResults[0].message);
    }

    useEffect(() => {
        getAIAdCopyActions().then(data => {
            if (data!=null){
                if (props.presets.formType=="EDIT"){
                    const origData = data;
                    const filter: FilterDescriptor = {
                        value: "Generate Ad Copy",
                        operator: "neq",
                        ignoreCase:true
                    };
                    console.log(filter);
                    data= filterBy(origData,{logic:"and",filters:[filter]});
                }
                setAIActions(data);
            }else{
                setAIActions([]);
            }
        });
        
        getAIAdCopyStyles().then(data => {
            console.log(data);
            if (data!=null){
                setAIStyles(data);
            }else{
                setAIStyles([]);
            }
        });
        
        if (props.presets.maxLength>0){
            setAIMaxLength(props.presets.maxLength);
        }   
        
        if (props.presets.prompt!=""){
            setPromptText(props.presets.prompt);
        }
    }, []);
    return(
        <Dialog title={"Ad Copy Assistant"} width={500} onClose={props.onClose}>
            {showForm?
                <>
                <label className='mb-2'>What would you like help with?</label>
                <DropDownList
                    data={aiActions}
                    value={action}
                    onChange={actionChange}
                />
                <label className='mt-3 mb-2'>What type of ad copy would you like?</label>
                <DropDownList
                    data={aiUnits}
                    value={selUnit}
                    onChange={unitChange}
                    dataItemKey='actionUnitOption'
                    textField='actionUnitOption'
                />
                <label className='mt-3 mb-2'>How much ad copy would you like? (Max of {lengthMax} {units} allowed)</label>
                <NumericTextBox value={aiMaxLength} max={lengthMax > 0 ? lengthMax : undefined} disabled={changeLength} onChange={maxChange}/>
                <div className="mt-3" style={{display:"flex"}}>{showEmoji?<Checkbox checked={aiEmojis} label="Allow emojis"/>:null}&emsp;{showHashtag?<Checkbox checked={aiHashtags}label="Allow hashtags"/>:null}</div>

                <label className='mt-3 mb-2'>What style should the ad copy be in?</label>
                <DropDownList
                    data={aiStyles}
                    value={selStyle}
                    dataItemKey='styleOption'
                    textField='styleOption'
                    onChange={styleChange}
                />
                <label className='mt-3 mb-2'>What should the ad copy be based on? We will use this text to help create your ad copy.</label>
                <TextArea rows={5} onChange={promptChange} value={promptText}></TextArea>
                </>
            :null}
            {showResult?
                <>
                <label className='mt-3 mb-2'>Your request:</label>
                <TextArea rows={5} value={aiMessage}></TextArea>
                <label className='mt-3 mb-2'>Generated ad copy:</label>
                <div>
                <ListBox
                    data={aiResults}
                    textField='message'
                    style={{width:"100%"}}
                />
                </div>
                <p className='mt-3'>Select from the three choices above. Use the SELECT button to add the selected copy to your submission. Use the BACK button to modify your request.</p>
                </>
            :null}
            <DialogActionsBar>                
                <Button onClick={props.onClose}>Cancel</Button>
                {showResult?<Button onClick={goBack}>Back</Button>:null}
                {showForm?<Button onClick={getAdCopy}>Get Copy</Button>:null}
                {showResult?<Button onClick={returnResults}>Select</Button>:null}

            </DialogActionsBar>
        </Dialog>
    )
}